import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-06b7aff5"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Firecracker Vocabulary Flashcards", -1))
const _hoisted_2 = ["target"]
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  href: "https://play.google.com/store/apps/details?id=com.emtiajium.firecracker.collaborative.vocab.practice",
  target: "_blank"
}, "mobile app", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "firstname", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "lastname", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "email address", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "profile picture (avatar)", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  href: "https://policies.google.com/privacy",
  target: "_blank"
}, "Google's Privacy Policy", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  href: "https://myaccount.google.com/privacy#toolsyoucanusenow",
  target: "_blank"
}, "Google activity controls", -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", { href: "mailto:271emtiaj@gmail.com" }, "271emtiaj@gmail.com", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_firecracker_header = _resolveComponent("firecracker-header")!
  const _component_ion_card_subtitle = _resolveComponent("ion-card-subtitle")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_ion_card_content = _resolveComponent("ion-card-content")!
  const _component_ion_card = _resolveComponent("ion-card")!
  const _component_ion_col = _resolveComponent("ion-col")!
  const _component_ion_row = _resolveComponent("ion-row")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withCtx(() => [
      _createVNode(_component_firecracker_header, {
        type: "MENU",
        "header-title": "Privacy Policy",
        "content-id": "privacy-policy",
        "menu-id": "privacy-policy-menu"
      }),
      _createVNode(_component_ion_content, {
        fullscreen: true,
        id: "privacy-policy"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_ion_row, { class: "display-flex ion-justify-content-center margin-bottom-4" }, {
            default: _withCtx(() => [
              _createVNode(_component_ion_col, {
                sizeXs: "12",
                sizeSm: "12",
                sizeMd: "10",
                sizeLg: "8",
                sizeXl: "8"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_card, { class: "margin-top-bottom-unset" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_card_content, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_card_subtitle, { class: "link-container" }, {
                            default: _withCtx(() => [
                              _createTextVNode(" Welcome to "),
                              _hoisted_1,
                              _createTextVNode("! Your privacy is important to us. This Privacy Policy explains how we collect, store, use, disclose and otherwise process your information when you use "),
                              _createElementVNode("a", {
                                href: "https://firecrackervocabulary.com",
                                target: _ctx.isAndroid ? '_blank' : '_self'
                              }, "https://firecrackervocabulary.com", 8, _hoisted_2),
                              _createTextVNode(", and our "),
                              _hoisted_3,
                              _createTextVNode(". ")
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_ion_card_subtitle, { class: "ion-padding-top header" }, {
                            default: _withCtx(() => [
                              _createTextVNode(" Information Collection ")
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_ion_card_subtitle, { class: "ion-padding-top link-container" }, {
                            default: _withCtx(() => [
                              _createTextVNode(" There is certain information that we collect automatically when you sign-up through Google, and authorize us to collect your authentication information, such as your "),
                              _hoisted_4,
                              _createTextVNode(", "),
                              _hoisted_5,
                              _createTextVNode(", "),
                              _hoisted_6,
                              _createTextVNode(", and "),
                              _hoisted_7,
                              _createTextVNode(". Google will ask your permission to share above mentioned information under the terms of "),
                              _hoisted_8,
                              _createTextVNode(" from your Google account. You can regulate the information that we receive from Google using your "),
                              _hoisted_9,
                              _createTextVNode(". Other than those pieces of information, we don't store any kind of data of you without your consent. ")
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_ion_card_subtitle, { class: "ion-padding-top header" }, {
                            default: _withCtx(() => [
                              _createTextVNode(" Information Usage")
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_ion_card_subtitle, { class: "ion-padding-top" }, {
                            default: _withCtx(() => [
                              _createTextVNode(" We store the collected data into our database to operate and maintain your account, identify you, for example, as the vocabulary creator, to create and maintain a cohort. ")
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_ion_card_subtitle, { class: "ion-padding-top header" }, {
                            default: _withCtx(() => [
                              _createTextVNode(" Information Sharing")
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_ion_card_subtitle, { class: "ion-padding-top" }, {
                            default: _withCtx(() => [
                              _createTextVNode(" We share your name, avatar, email address and vocabulary you created with the other members if you join a cohort with them. However, we do not share your data with any third-party user, either provided by Google (during the sign-up) or the vocabulary you created. ")
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_ion_card_subtitle, { class: "ion-padding-top header" }, {
                            default: _withCtx(() => [
                              _createTextVNode(" Information Disclose")
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_ion_card_subtitle, { class: "ion-padding-top" }, {
                            default: _withCtx(() => [
                              _createTextVNode(" We collect and transmit data using industry-standard SSL (Secure Socket Layer) encryption. We authenticate, authorize every request in a secure manner for your safeness. ")
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_ion_card_subtitle, { class: "ion-padding-top header" }, {
                            default: _withCtx(() => [
                              _createTextVNode(" Information Deletion")
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_ion_card_subtitle, { class: "ion-padding-top link-container" }, {
                            default: _withCtx(() => [
                              _createTextVNode(" We have a "),
                              _createVNode(_component_router_link, { to: "goodbye" }, {
                                default: _withCtx(() => [
                                  _createTextVNode("deletion request page")
                                ]),
                                _: 1
                              }),
                              _createTextVNode(" if you want to delete your Google-provided info, your created vocabulary, or any data we have. ")
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_ion_card_subtitle, { class: "ion-padding-top header" }, {
                            default: _withCtx(() => [
                              _createTextVNode(" Contact Information")
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_ion_card_subtitle, { class: "ion-padding-top email-container" }, {
                            default: _withCtx(() => [
                              _createTextVNode(" If you do not agree to any of the provisions of this privacy policy, you should not use the Platform. Do not hesitate to mail us at "),
                              _hoisted_10,
                              _createTextVNode(" for any kind of query. ")
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}